import { render } from "./XIconSolidGitCompare.vue?vue&type=template&id=c48934fe"
import script from "./XIconSolidGitCompare.vue?vue&type=script&lang=js"
export * from "./XIconSolidGitCompare.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidGitCompare.vue"]])

export default __exports__